'use client';

import { usePathname, useSearchParams } from 'next/navigation';

export function useAsPath() {
  const pathname = usePathname() || '';
  const searchParams = useSearchParams();

  const pathParams = searchParams?.toString()
    ? `?${searchParams.toString()}`
    : '';

  const asPathUrl = `${pathname}${pathParams}`;

  return {
    asPathUrl,
    pathParams,
  };
}
